import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowUp, faArrowDown, faFlagCheckered } from "@fortawesome/free-solid-svg-icons"
import styled from 'styled-components';
import {useSpring, animated} from 'react-spring'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(1),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));

const Styledbutton = styled(Button)`
    background-color: var(--green-primary-full);
    padding: 4px  8px;
    &:hover{
        background-color: var(--green-primary);
    }
    font-family: "lato";
    font-weight: 900;
    font-size: 25px;
    min-width: auto;
`
const AnimatedStepContent = animated(StepContent);

const Styledbackbutton = styled(Button)`
    padding: 4px  8px;
    font-family: "lato";
    font-weight: 900;
    font-size: 25px;
    min-width: auto;
`

const StyledStepLabel = styled(StepLabel)`

    .MuiStepLabel-label{
        font-size: 17px;
        font-family: "lato";
     font-weight: 900;
    }
    circle{
        fill: var(--blue-primary);
    }
    .MuiStepIcon-root.MuiStepIcon-completed{
        fill: var(--green-primary);
    }


`

export default function Stappen({stappenplan}) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const newsteps = stappenplan;


  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} orientation="vertical">
        {newsteps[0].titels.map((label, index) => (
          <Step key={label.titel}>
            <StyledStepLabel>{label.titel}</StyledStepLabel>
            <AnimatedStepContent>
              <p>{newsteps[0].inhoud[index].text}</p>
              <div className={classes.actionsContainer}>
                <div>
                  <Styledbackbutton
                    variant="contained"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className={classes.button}
                  >
                    <FontAwesomeIcon icon={faArrowUp} />
                  </Styledbackbutton>
                  <Styledbutton
                    variant="contained"
                    onClick={handleNext}
                    disabled={activeStep === (newsteps[0].titels.length - 1)}
                    className={classes.button}
                  >
                     <FontAwesomeIcon icon={faArrowDown}/>
                  </Styledbutton>
                </div>
              </div>
            </AnimatedStepContent>
          </Step>
        ))}
      </Stepper>
      {activeStep === newsteps[0].titels.length && (
        <Paper square elevation={0} className={classes.resetContainer}>
          <p>Einde Process</p>
          <Button onClick={handleReset} 
            variant="contained"
            className={classes.button}>
            Bekijk opnieuw
          </Button>
        </Paper>
      )}
    </div>
  );
}